import API_CONFIG from '../config/api';

// Browser-side activity trail: which page or profile tab an admin opened,
// which document they looked at, what they saved from the browser. Posts to
// /api/admin/activity/log, which only accepts these action types and skips
// the owner account. Fire-and-forget: a failed log never blocks the UI.
const RECENT_WINDOW_MS = 3000;
const recent = new Map();

const sessionUserId = () => {
    try {
        const session = JSON.parse(localStorage.getItem('adminSession') || 'null');
        return session?.userId || session?.id || null;
    } catch (e) {
        return null;
    }
};

export function logAdminActivity(action, description, { targetType = null, targetId = null } = {}) {
    const userId = sessionUserId();
    if (!userId || !action || !description) return;

    // The same event fired twice in quick succession (a re-render, a double
    // click, React strict-mode effects) is one event.
    const key = `${userId}|${action}|${description}|${targetType}|${targetId}`;
    const now = Date.now();
    if ((recent.get(key) || 0) > now - RECENT_WINDOW_MS) return;
    recent.set(key, now);
    if (recent.size > 200) {
        for (const [k, at] of recent) if (at < now - RECENT_WINDOW_MS) recent.delete(k);
    }

    try {
        fetch(`${API_CONFIG.BASE_URL}/api/admin/activity/log`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'x-user-id': userId },
            body: JSON.stringify({ action, description, targetType, targetId }),
            keepalive: true
        }).catch(() => { /* the trail is best-effort */ });
    } catch (e) {
        /* never block the UI on the trail */
    }
}
